<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <div class="columns">
      <div class="column is-two-thirds">
        <vue-element-loading
          :active="isLoading"
          spinner="spinner"
          background-color="rgba(255, 255, 255, 1)"
        />
        <div v-if="isExist">
          <h5 class="title is-5">
            {{ event.deviceLocate }}
          </h5>
          <div v-html="movieUrl" style="width: 100%"></div>
          <div class="has-text-centered">
            {{ event.deviceId }} |
            <DateFormat :timestamp="event.eventDateTime" /> ({{ timezone }})
            <a download @click="movieDownload()">
              <i class="fas fa-cloud-download-alt"></i>
              {{ $t("movie.download") }}</a
            >
          </div>
          <p
            v-if="projectRole == 'admin'"
            class="mt-3 notification is-info is-light"
          >
            {{ $t("movie.claimMessage1") }}<br />
            <a download @click="openModal()"> {{ $t("movie.claim") }}</a>
          </p>
        </div>
        <div v-else>
          <h5 class="title is-5">{{ $t("movie.notFoundTitle") }}</h5>
          <p class="notification is-info is-light">
            {{ $t("movie.notFound") }}
          </p>
        </div>
      </div>
    </div>
    <Modal
      v-if="projectRole == 'admin'"
      :imageModalView="imageModalView"
      :modalTitle="$t('movie.reportTitle')"
      :modalAction="$t('movie.delete')"
      :buttonColor="'is-danger'"
      @close="closeModal"
      @doAction="claimMovie()"
    >
      <p>
        {{ $t("movie.claimMessage2") }}<br />
        {{ $t("movie.claimMessage3") }}
      </p>
      <p>
        {{ $t("movie.claimMessage4") }}<br />
        {{ $t("movie.claimMessage5") }}
      </p>
    </Modal>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import Modal from "@/components/Modal";
import imsr from "@/imsr-api";
import imsrconfig from "@/imsr-exports";
import { computed, ref } from "vue";
import VueElementLoading from "vue-element-loading";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import DateFormat from "@/components/DateFormat";

export default {
  components: {
    Breadcrumb,
    VueElementLoading,
    DateFormat,
    Modal,
  },
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const userId = computed(() => store.getters.userId);
    const event = ref({});
    const movieUrl = ref();
    const isLoading = ref(false);
    const imageModalView = ref(false);
    const modalMessage = ref("");
    const targetImage = ref("");
    const isExist = ref(true);

    const breadcrumb = computed(() => {
      let base = [
        {
          title: "Home",
          path: {
            name: "dashboard",
            params: { projectId: route.params.projectId },
          },
        },
      ];

      if (route.query.mode == "event") {
        base.push(
          {
            title: "Event",
            path: {
              name: "eventsList",
              params: { projectId: route.params.projectId },
              query: {
                date: route.query.date,
              },
            },
          },
          { title: "Movie", path: "#", isActive: true }
        );
      } else {
        base.push(
          {
            title: "Data",
            path: {
              name: "dataList",
              params: { projectId: route.params.projectId },
            },
          },
          {
            title: route.params.deviceId,
            path: {
              name: "dataView",
              params: {
                projectId: route.params.projectId,
                deviceId: route.params.deviceId,
              },
              query: {
                date: route.query.date,
              },
            },
          },
          { title: "Movie", path: "#", isActive: true }
        );
      }
      return base;
    });
    const getMovie = async () => {
      try {
        if (store.getters.projectId != route.params.projectId) {
          const params = {
            tenantId: store.getters.tenantId,
            projectId: route.params.projectId,
          };
          const project = await imsr.imsrGetApi("/projects", params);
          store.commit("setProjectId", route.params.projectId);
          store.commit("setProjectName", project.projectName);
        }
        isLoading.value = true;
        let params = {
          tenantId: store.getters.tenantId,
          projectId: route.params.projectId,
          deviceId: route.params.deviceId,
          eventDateTime: parseInt(route.params.eventDateTime),
        };
        event.value = await imsr.imsrGetApi("/events", params);
        params = {
          tenantId: event.value.tenantId,
          projectId: event.value.projectId,
        };
        const ticket = await imsr.imsrGetApi("/projects/getTicket", params);
        const query =
          "?userId=" +
          userId.value +
          "&tenantId=" +
          event.value.tenantId +
          "&projectId=" +
          event.value.projectId +
          "&ticket=" +
          ticket.movieTicket +
          "&time=" +
          ticket.time;
        const url = encodeURI(
          imsrconfig.movie + event.value.file + query
        ).replace("+", "%2B");
        movieUrl.value =
          '<video class="movie-file" controlslist="nodownload" controls autoplay muted preload="on" poster="/img/blank.png">' +
          '<source src="' +
          url +
          '" type="video/mp4"/>' +
          "</video>";
        isLoading.value = false;
        isExist.value = true;
      } catch (error) {
        isLoading.value = false;
        if (error.status == 404) {
          isExist.value = false;
        } else {
          router.push({ name: "InternalServerError" });
        }
      }
    };
    getMovie();

    const movieDownload = async () => {
      const params = {
        tenantId: event.value.tenantId,
        projectId: event.value.projectId,
      };
      const ticket = await imsr.imsrGetApi("/projects/getTicket", params);
      const query =
        "?userId=" +
        userId.value +
        "&tenantId=" +
        event.value.tenantId +
        "&projectId=" +
        event.value.projectId +
        "&ticket=" +
        ticket.movieTicket +
        "&time=" +
        ticket.time;
      const url = encodeURI(
        imsrconfig.movie + event.value.file + query
      ).replace("+", "%2B");
      window.open(url, "_blank");
    };

    const openModal = () => {
      imageModalView.value = true;
    };
    const closeModal = () => {
      imageModalView.value = false;
    };

    const claimMovie = async () => {
      try {
        const params = {
          tenantId: store.getters.tenantId,
          projectId: route.params.projectId,
          deviceId: route.params.deviceId,
          eventDateTime: parseInt(route.params.eventDateTime),
        };
        await imsr.imsrGetApi("/events/claim", params);
        store.commit("setMessage", t("movie.claimSuccess"));
        if (route.query.mode == "event") {
          router.push({
            name: "eventsList",
            params: { projectId: route.params.projectId },
            query: {
              date: route.query.date,
            },
          });
        } else {
          router.push({
            name: "dataView",
            params: {
              projectId: route.params.projectId,
              deviceId: route.params.deviceId,
            },
            query: {
              date: route.query.date,
            },
          });
        }
      } catch (error) {
        router.push({ name: "InternalServerError" });
      }
    };

    return {
      tenantId: computed(() => store.getters.tenantId),
      projectId: computed(() => route.params.projectId),
      projectRole: computed(() => store.getters.projectRole),
      timezone: computed(() => store.getters.timezone),
      isExist,
      movieUrl,
      event,
      breadcrumb,
      isLoading,
      movieDownload,
      imageModalView,
      modalMessage,
      targetImage,
      openModal,
      closeModal,
      claimMovie,
    };
  },
};
</script>
<style scoped>
video {
  width: 100%;
}
</style>
